export default __webpack_public_path__ + "static/banner-vms-f811d672fce7e9708a8c0cb0967f28f1.png";